import { takeLatest, put, call } from 'redux-saga/effects';
import { getListCustoProcedimentos } from '../service';
import { formatDateDDMMYYYY } from '@components/common/format';
import {
    CONFIG_SESSION,
    CUSTO_LIST_PROCEDIMENTOS,
    CUSTO_LIST_PROCEDIMENTOS_PENDING,
    CUSTO_LIST_PROCEDIMENTOS_SUCCESS,
    CUSTO_LIST_PROCEDIMENTOS_FAILURE,
} from '@handler';
import { storage } from '@commons/storage';

function* fetchListCustoProcedimentos(action) {
  yield put({ type: CUSTO_LIST_PROCEDIMENTOS_PENDING });

  try {
    const session = JSON.parse(storage.get(CONFIG_SESSION));
    const idFazenda = session.fazendaSelecionada?.id ?? -1;
    const idSafra = session.safraAtiva?.id ?? -1;
    const dataInicial = formatDateDDMMYYYY(action.dataInicial);
    const dataFinal = formatDateDDMMYYYY(action.dataFinal);

    const dadosListCustosProcedimentos = yield call(getListCustoProcedimentos, idFazenda, idSafra, dataInicial, dataFinal);
    yield put({ type: CUSTO_LIST_PROCEDIMENTOS_SUCCESS, dadosListCustosProcedimentos });
  } catch (err) {
    yield put({ type: CUSTO_LIST_PROCEDIMENTOS_FAILURE });
  }
}

export default function* watchListCustoProcedimentos() {
  yield takeLatest(CUSTO_LIST_PROCEDIMENTOS, fetchListCustoProcedimentos);
}
